import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { getBikeHpiCheck } from '../../requests/bike_hpi_check_request';
import { getBikeHpiCheckSuccess, getBikeHpiCheckFailure } from '../actions/bike_hpi_check.actions';
import { GET_BIKE_HPI_CHECK } from '../constants/bike_hpi_check.constants';

function* getBikeHpiCheckRequest({ bike_id }) {
    const { result, error, options } = yield call(getBikeHpiCheck, bike_id);
    if (result) {
        yield put(getBikeHpiCheckSuccess(options));
    } else {
        yield put(getBikeHpiCheckFailure(error));
        message.error(error.message);
    }
}

export default function* getBikeHpiCheckSaga() {
    yield takeEvery(GET_BIKE_HPI_CHECK, getBikeHpiCheckRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_bike_hpi_check.saga.js